(function(){
  document.addEventListener('DOMContentLoaded', function() {
    // if ('scrollRestoration' in history) {
    //   history.scrollRestoration = 'manual';
    // }
    // var isOnIOS = navigator.userAgent.match(/iPad/i)|| navigator.userAgent.match(/iPhone/i);
    // var eventName = isOnIOS ? "pagehide" : "beforeunload";
    // window.addEventListener(eventName, (event) => {
      
    //   var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    //   var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      
    //   var centerX = windowWidth / 2;
    //   var centerY = windowHeight / 2;
      
    //   var elementsInCenter = document.elementsFromPoint(centerX + 100, centerY);
    //   let centeredProductId = elementsInCenter[0]
    //                           .closest('li.grid__item').dataset.productId;
      
    //   let nextButton = document.querySelector('#pagination-wrapper .infinite_next a'); 
    //   if ( nextButton ) {
    //     var link = nextButton.getAttribute('href');
    //     var url = new URL(link, 'https://ainker.com/');
    //     var page = url.searchParams.get("page");
    //     var url = new URL(location.href);
    //     url.searchParams.set("IdToScroll", centeredProductId);
    //     url.searchParams.set("page", page - 1);
    //     var newURL = url;
    //     history.replaceState({}, '', newURL);
    //   }
    // });
    
    // var url = new URL(location.href);
    // var IdToScroll = url.searchParams.get("IdToScroll");
    // if ( IdToScroll ) { 
    //   let toScroll = document.querySelectorAll(`li.grid__item[data-product-id="${IdToScroll}"]`);
    //   if ( ! toScroll ) return false;
    //   toScroll = toScroll[0];
      
    //   if (toScroll) {
    //     var windowHeight = window.innerHeight;
        
    //     // Get element height (includes padding, border, but not margin)
    //     var elementRect = toScroll.getBoundingClientRect();
    //     var elementHeight = elementRect.height;

    //     // Get offset top (distance from top of viewport)
    //     var offsetTop = elementRect.top + window.scrollY;

    //     if (isNaN(offsetTop)) return false;

    //     var scrollPosition = offsetTop - (windowHeight / 2) + (elementHeight / 2);

    //     window.scroll({
    //       top: scrollPosition,
    //       behavior: 'smooth'
    //     });
    //   }
      
    //   const urlParams = new URLSearchParams(window.location.search);
    //   urlParams.delete("IdToScroll");
    //   const newUrl = `${window.location.origin}${window.location.pathname}?${urlParams.toString()}`;
    //   history.replaceState(null, "", newUrl);
    // }
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  const STORAGE_KEY = 'shopify_scroll_data';
  let scrollTimeout;

  // 1. Функция сохранения (вызывается при остановке скролла)
  const saveCurrentState = () => {
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    
    // Проверка 3-х точек по вертикали (центр, чуть выше, чуть ниже) против баннеров
    const scanPoints = [0.5, 0.4, 0.6];
    let centeredProductId = null;

    for (let point of scanPoints) {
      const elements = document.elementsFromPoint(windowWidth / 2, windowHeight * point);
      const item = Array.from(elements).find(el => el.closest('li.grid__item'));
      if (item) {
        const container = item.closest('li.grid__item');
        centeredProductId = container.dataset.productId || container.querySelector('[name="id"]')?.value;
        if (centeredProductId) break;
      }
    }

    if (!centeredProductId) return;

    // Логика пагинации (как в вашем исходном коде)
    let pageToRestore = 1;
    const nextButton = document.querySelector('#pagination-wrapper .infinite_next a');

    if (nextButton) {
        const href = nextButton.getAttribute('href');
        // Используем URLSearchParams напрямую для надежности
        const urlParams = new URLSearchParams(href.split('?')[1]);
        const pageValue = urlParams.get("page");
        
        if (pageValue) {
            pageToRestore = parseInt(pageValue) - 1;
        }
    }else {
      // Если кнопки "Next" нет, возможно мы на последней странице
      pageToRestore = new URL(location.href).searchParams.get("page") || 1;
    }

    const url = new URL(location.href);

    const data = { id: centeredProductId, page: pageToRestore, url: url.pathname };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  };

  if ( document.body.classList.contains('template-collection')) {
     // 2. Слушаем скролл с задержкой (чтобы не тормозило на iOS)
    window.addEventListener('scroll', () => {
        
        // debugger;
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(saveCurrentState, 150);
      }, { 
        passive: true, 
        capture: true  // <-- Это заставит скрипт ловить скролл внутри любых дивов
    });
  }
 

 

document.addEventListener('click', function(event) {
    // 1. Ищем, был ли клик по карточке товара или ссылке внутри неё
    const productCard = event.target.closest('li.grid__item');
    const link = event.target.closest('a');

    // Если клик не по карточке или нет ссылки — ничего не делаем
    if (!productCard || !link) return;

    // Проверяем, что ссылка ведет на страницу продукта (а не "в корзину" или "избранное")
    const destinationUrl = link.getAttribute('href');
    if (!destinationUrl || destinationUrl.startsWith('#') || destinationUrl.includes('cart/add')) return;

    // ОСТАНАВЛИВАЕМ переход на мгновение
    event.preventDefault();

    // 2. ЛОГИКА СОХРАНЕНИЯ СОСТОЯНИЯ
    const productId = productCard.dataset.productId || productCard.querySelector('[name="id"]')?.value;
    
    let pageToRestore = 1;
    const nextButton = document.querySelector('#pagination-wrapper .infinite_next a');
    
    if (nextButton) {
      const nextHref = nextButton.getAttribute('href');
      // Безопасный парсинг страницы из ссылки
      const urlParams = new URLSearchParams(nextHref.split('?')[1]);
      const pageValue = urlParams.get("page");
      if (pageValue) {
        pageToRestore = parseInt(pageValue) - 1;
      }
    }

    // 3. ОБНОВЛЯЕМ ТЕКУЩУЮ ИСТОРИЮ (этой страницы коллекции)
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set("IdToScroll", productId);
    currentUrl.searchParams.set("page", pageToRestore);
    
    // Заменяем текущую запись в истории, чтобы при нажатии "Назад" мы вернулись по этой ссылке
    history.replaceState(null, '', currentUrl.toString());

    // 4. ПЕРЕХОДИМ НА СТРАНИЦУ ПРОДУКТА
    // Используем setTimeout 0, чтобы браузер успел завершить replaceState
    setTimeout(() => {
      window.location.href = destinationUrl;
    }, 0);

  }, true); // Используем capture mode (true), чтобы поймать клик раньше других скриптов

  // 5. ЛОГИКА ВОССТАНОВЛЕНИЯ (при возврате)
  const restoreScroll = () => {
  const params = new URLSearchParams(window.location.search);
  const id = params.get("IdToScroll");

  if (id) {
    // Небольшая задержка, чтобы браузер успел восстановить DOM
    setTimeout(() => {
      const target = document.querySelector(`li.grid__item[data-product-id="${id}"]`) || 
                     document.querySelector(`li.grid__item [value="${id}"]`)?.closest('li.grid__item');

      if (target) {
        const rect = target.getBoundingClientRect();
        const offset = (window.pageYOffset || document.documentElement.scrollTop) + rect.top - (window.innerHeight / 2) + (rect.height / 2);
        
        window.scrollTo({ top: offset, behavior: 'smooth' });

        // Очистка URL
        params.delete("IdToScroll");
        const cleanUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
        history.replaceState(null, '', cleanUrl);
      }
    }, 200); // 200мс обычно хватает для мгновенного возврата
  }
};

// Это событие срабатывает ПРИ КАЖДОМ появлении страницы (включая "Назад" в Safari)
window.addEventListener('pageshow', (event) => {
  // event.persisted === true означает, что страница загружена из bfcache
  restoreScroll();
});

// На всякий случай оставляем и для обычной загрузки
if (document.readyState === 'complete') restoreScroll();

    console.log('jsfile');
    let sliderThumbs,
        sliderProductMain;
    // if ( document.querySelector('.slider--thumbs') ) {
    //   sliderThumbs = new Swiper('.slider--thumbs', {
    //     direction: 'vertical',
    //     slidesPerView: 'auto',
    //     spaceBetween: 9,
    //     loop: true,
    //     initialSlide: 1,
    //     navigation: {
    //       nextEl: '.swiper-button-next',
    //       prevEl: '.swiper-button-prev',
    //     },
    //     freeMode: true,
    //   });
    // }

    // window.sizesSlider = function sizesSlider() {
    //   if ( document.querySelector('.js-card-size-slider') ) {
    //     new Swiper('.js-card-size-slider', {
    //       slidesPerView: 'auto',
    //       spaceBetween: 15,
    //       // centeredSlides: true,
    //       loop: false,
    //       // initialSlide: 1,
    //       navigation: {
    //         nextEl: '.swiper-button-next',
    //         prevEl: '.swiper-button-prev',
    //       },
    //       // freeMode: true,
    //     });
    //   }
    // }
    // window.sizesSlider();

    
    if ( document.querySelector('.slider--main') ) {
      /*   *-*************************************************************/
      sliderProductMain = new Swiper('.slider--main', {
        spaceBetween: 0,
        slidesPerView: 'auto',
        centeredSlides: false,
        loop: true,
        initialSlide: 0,
        grabCursor: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          type: "progressbar",
          el: ".swiper-pagination",
          clickable: true,
        },
        // thumbs: {
        //   swiper: sliderThumbs,
        // },
        breakpoints: {
          750: {
            slidesPerView: 'auto',
            spaceBetween: 0,
            centeredSlides: false,
            initialSlide: 0,
          },
          990: {
            slidesPerView: 'auto',
            spaceBetween: 0,
            centeredSlides: false,
          },
        },
      });
    }
    

    
    /**
     * Code for changing slides in product slide for each variant
     */
    // let productCur = document.querySelector('[data-tb-variants-json]');
    // if (productCur) {
    //   productCur = JSON.parse(productCur.getAttribute('data-tb-variants-json'));
    // }
    
    // function variantImage(val) {
    //   const selectedVariantId = parseInt(val, 10);
    //   const variant = productCur.filter(v => v.id === selectedVariantId);
      
    //   const slickElements = document.querySelectorAll('[data-for-slick]');
    //   if (slickElements.length > 1 && document.querySelector(`[data-for-slick="${variant[0]?.featured_media?.id}"]`)) {
    //     const activeMedia = document.querySelector(`[data-for-slick="${variant[0].featured_media.id}"]`).getAttribute('aria-label');
    //     const numbers = activeMedia.split("/");
    //     const firstNumber = parseInt(numbers[0]);
    //     sliderProductMain.slideTo(firstNumber - 1);
    //     sliderProductMain.slideTo(firstNumber - 1);
    //   }
    // }
    
    // const initialColorVariant = document.querySelector('product-info .product-variant-id');
    // initialColorVariant?.addEventListener('change', function(event) {
    //   const currentVariant = document.querySelector('.product-variant-id');
      
    //   if (currentVariant) {
    //     const selectedVariantId = currentVariant.value;
    //     variantImage(selectedVariantId);
    //   }
    // });
    
  }, false);



  
  window.addEventListener('DOMContentLoaded', function(){
      /*   *-*************************************************************/
      // init sliderProductCard
     //  let productMedia = document.querySelector('[data-product-media]');
    
    function isSliderFeatured(elem) {
      if ( elem.closest('.slider_featured') ) {
        return false;
      } else  {
        return true;
      }
    }
    window.sliderProductCard = function() {
      // 1. Находим все элементы, которые подходят под селектор инициализации
      const sliderProductCards = document.querySelectorAll('.slider--card:not(.swiper-initialized)');

      // 2. Проходим по каждому найденному элементу
      sliderProductCards.forEach(sliderEl => {

        // 3. Проверяем наличие родительского класса 'featured_slider' у текущего элемента
        const isFeatured = sliderEl.closest('.slider_featured') !== null;
        console.log('isFeatured', sliderEl.closest('.slider_featured'));
        // 4. Определяем значение allowTouchMove для мобильных устройств (0px breakpoint)
        // Если это featured_slider, устанавливаем false, иначе - true
        const touchMoveMobileValue = isFeatured ? false : true;
        // debugger;
        // 5. Инициализируем Swiper для текущего элемента, используя динамическое значение
        const swiperInstance = new Swiper(sliderEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            type: 'progressbar',
            el: ".swiper-pagination",
            clickable: true,
          },
          grabCursor: true,
          allowTouchMove: true, // Базовое значение для десктопа
          breakpoints: {
            0: {
              // Устанавливаем значение, определенное на шаге 4
              allowTouchMove: touchMoveMobileValue,
            },
            750: {
              allowTouchMove: true,
            },
          },
          on: {
            init: function () {
              if (this.slides.length < 2) {
                this.el.classList.add('disabled');
              }
            }
          },
        });
      });

    };
    window.sliderProductCard();

    
  });
})();
